module.exports = __webpack_public_path__ + "img/icon-fans.8c260e7c.svg";